/**
 * Configuración › Usuarios › Sucursales del usuario (window.FDSucursalesUsuario): orden, búsqueda, filtros y cambios
 * del gestor. Funciones puras (Vitest en entorno node, sin DOM); la vista noble/configuracion/usuarios.php pinta y
 * v2/Usuarios::guardar_sucursales_ajax vuelve a validar todo.
 *
 * Pastelería Lety (Claudia Pintor, 20-oct-2026): la lista salía en el orden en que se asignaron, sin código, sin
 * buscador y de una en una. Una sucursal: { guid, alias (el código), nombre, matriz }.
 */

var COLLATOR = new Intl.Collator('es', { numeric: true, sensitivity: 'base' });

/** Orden natural del código: 1, 2, 10, 100; 002 antes que 010; A2 antes que A10. Sin código, al final. */
export function compararCodigo(a, b) {
  var x = a == null ? '' : String(a).trim();
  var y = b == null ? '' : String(b).trim();
  if (x === '' || y === '') return x === y ? 0 : (x === '' ? 1 : -1);
  return COLLATOR.compare(x, y);
}

/** Una copia ordenada por código (natural, por omisión) o por nombre; el empate lo resuelve el otro campo. */
export function ordenar(lista, opciones) {
  var o = opciones || {};
  var signo = o.dir === 'desc' ? -1 : 1;
  var porNombre = o.por === 'nombre';
  return (lista || []).slice().sort(function (a, b) {
    var r = porNombre ? COLLATOR.compare(String(a.nombre || ''), String(b.nombre || '')) : compararCodigo(a.alias, b.alias);
    if (r === 0) r = porNombre ? compararCodigo(a.alias, b.alias) : COLLATOR.compare(String(a.nombre || ''), String(b.nombre || ''));
    return r * signo;
  });
}

/** Minúsculas, sin acentos y con un solo espacio entre palabras. */
export function normalizar(texto) {
  return String(texto == null ? '' : texto).normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().replace(/\s+/g, ' ').trim();
}

/** Lo que se ve: { texto (código o nombre, sin acentos; el código también sin sus ceros), vista: todas|asignadas|sin }. */
export function filtrar(lista, filtro, marcadas) {
  var f = filtro || {};
  var q = normalizar(f.texto);
  var vista = f.vista || 'todas';
  var m = marcadas || new Set();
  return (lista || []).filter(function (s) {
    var asignada = m.has(s.guid);
    if (vista === 'asignadas' && !asignada) return false;
    if (vista === 'sin' && asignada) return false;
    if (q === '') return true;
    var codigo = normalizar(s.alias);
    return codigo.indexOf(q) !== -1 || codigo.replace(/^0+(?=.)/, '').indexOf(q) !== -1 || normalizar(s.nombre).indexOf(q) !== -1;
  });
}

/** Los números de los chips Todas / Asignadas / Sin asignar. */
export function conteos(lista, marcadas) {
  var m = marcadas || new Set();
  var todas = (lista || []).length;
  var asignadas = (lista || []).filter(function (s) { return m.has(s.guid); }).length;
  return { todas: todas, asignadas: asignadas, sin: todas - asignadas };
}

/** Un conjunto nuevo con las visibles marcadas (valor true) o desmarcadas; las que no se ven quedan como estaban. */
export function marcarVisibles(marcadas, visibles, valor) {
  var m = new Set(marcadas || []);
  (visibles || []).forEach(function (s) { if (valor) m.add(s.guid); else m.delete(s.guid); });
  return m;
}

/** Qué cambia contra lo que trajo el servidor: { agregar: [guid], quitar: [guid], total }. */
export function cambios(original, marcadas) {
  var o = original || new Set();
  var m = marcadas || new Set();
  var agregar = [...m].filter(function (g) { return !o.has(g); });
  var quitar = [...o].filter(function (g) { return !m.has(g); });
  return { agregar: agregar, quitar: quitar, total: agregar.length + quitar.length };
}

/** El contador junto a los chips. Sin asignadas, el usuario factura con todas (Usuarios_model::sucursales_permitidas). */
export function textoContador(asignadas, total) {
  if (!asignadas) return 'Sin sucursales asignadas: factura con todas';
  return 'Asignadas: ' + asignadas + ' de ' + total;
}

/** Escapa texto para pintarlo dentro de HTML. */
export function esc(texto) {
  return String(texto == null ? '' : texto)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
